define(function (require, exports, module) {
    var ContentVideo = require('./ContentVideo');
    var isArray = Array.isArray;

    function ContentVideoList (list, type) {
        this.type = type;
        this.parseData(list);
    }

    ContentVideoList.prototype = {
        parseData: function (videos) {
            var cid = this.cid = {};
            var list = this.list = [];
            var condensed;
            var recap;

            if (videos) {
                videos = isArray(videos) ? videos : [videos];
                var hilite;
                var i = 0;
                var len = videos.length;

                for (; i < len; i++) {
                    hilite = new ContentVideo(videos[i]);
                    cid[hilite.id] = hilite;

                    if (hilite.condensed) {
                        this.condensed = condensed = hilite;
                    }

                    list.push(hilite);
                }
            }

            this.hasVideos = !!list.length;
        }
    };

    return ContentVideoList;
});
